module.exports = __webpack_public_path__ + "static/logo-47c8cf074d0bd4984a995e137757fac1.png";